import { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { Icon, NakedButton } from '@qga/roo-ui/components';
import { rem } from 'polished';
import { themeGet } from 'styled-system';

import {
  Slider,
  SliderProvider,
  useSlider,
} from '@shared/v2/components/Slider';

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Button = styled(NakedButton)`
  position: relative;
  border-radius: ${themeGet('radii.rounded')};
  height: ${rem('32px')};
  width: ${rem('32px')};
  background-color: ${({ colorMode }: { colorMode: string }) =>
    colorMode === 'light' ? 'white' : themeGet('colors.greys.charcoal')};
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

const ArrowControl = ({
  direction,
  onClick,
  colorMode,
  ...rest
}: {
  direction: 'left' | 'right';
  title: string;
  disabled: boolean;
  onClick: Function;
  colorMode: string;
}) => (
  <Button
    onClick={onClick}
    colorMode={colorMode}
    aria-label={direction}
    {...rest}
  >
    <StyledIcon
      color={colorMode === 'light' ? 'greys.charcoal' : 'white'}
      size={18}
      name={direction === 'left' ? 'chevronLeft' : 'chevronRight'}
    />
  </Button>
);

const LeftButton = () => {
  const { scrollPrevious, previousDisabled } = useSlider();

  return (
    <ArrowControl
      direction="left"
      title="PREVIOUS"
      colorMode="light"
      onClick={() => scrollPrevious()}
      disabled={previousDisabled}
    />
  );
};

const RightButton = () => {
  const { scrollNext, nextDisabled } = useSlider();

  return (
    <ArrowControl
      direction="right"
      title="NEXT"
      colorMode="light"
      onClick={() => scrollNext()}
      disabled={nextDisabled}
    />
  );
};

const Indicator = ({
  snapPointPosition,
  index,
}: {
  snapPointPosition: number;
  index: number;
}) => {
  const { selectedIndex } = useSlider();

  const isCurrentIndicatorDisabled = index !== selectedIndex;

  return (
    <Icon
      key={snapPointPosition}
      index={index}
      title="INDICATOR"
      name="circle"
      disabled={isCurrentIndicatorDisabled}
      size="8px"
      color={isCurrentIndicatorDisabled ? '#D9D9D9' : '#666666'}
    />
  );
};

const PackageOptionSlider = ({
  children,
  initialKey,
}: PropsWithChildren<{ initialKey?: string }>) => (
  <SliderProvider initialKey={initialKey}>
    <Slider
      Indicator={Indicator}
      LeftButton={LeftButton}
      RightButton={RightButton}
    >
      {children}
    </Slider>
  </SliderProvider>
);

export default PackageOptionSlider;
